import React, { useCallback, useEffect, useMemo, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { EditItemForm } from "./form";
import { useControl } from "../../../../controlContext";
import { useSource, useSourceReducer } from "../../../../sourceContext";
import { langTypeMap } from "../../../../../../shared/Data/langTypeMap";
import { getOptionsForLanguageEntryDropdown } from "../../../../../../scripts/reactBased/dataObjectHelpers";

export function ModalEditItem({show, setShow, name}){

  const [controls] = useControl()
  const source = useSource()
  const sourceReducer = useSourceReducer()
  const [state, setState ]= useState({})
  const idx = source[name] && source[name].findIndex(itm=>itm._id === controls[name])
  const item = source[name] && source[name][idx]
  const formSchema = useMemo(()=>langTypeMap[name].getFormSchema(getOptionsForLanguageEntryDropdown), [name])

  const confirmDisabled = useMemo(()=>(!langTypeMap[name].getFormSchema().every(itm=>((state[itm.name] && itm.required )|| !itm.required))), [name, state])
  const initialize = useCallback( init, [item, setState])
  useEffect(()=>{
    if(show) initialize()
  }, [show, initialize])

  function init(){
    if(item){
      const formData = item.getFormData()
      console.log('edititemform init', formData, item )
      setState(formData)
    }else{
      setState({})
    }
  }

  function close(){
    setShow(false)
    setState({})
  }

  function onConfirm(){
    console.log('setting form data to source item', idx, name, state)
    sourceReducer({type:'replace_item_form_data', idx, itemType:name, formData:state})
    close()
  }

  return (
    <Modal show={show} size="lg" onHide={close}>
      <Modal.Title>Edit Language Entry: {`(${name})`}</Modal.Title>
      <Modal.Body>
        <EditItemForm formData={state} formSchema={formSchema} onChange={(value, address)=>setState({...state, [address]: value })}/>
      </Modal.Body>
      <Modal.Footer>
        <Button disabled={confirmDisabled} onClick={onConfirm}>Confirm</Button>
        <Button onClick={close}>Cancel</Button>
      </Modal.Footer>
    </Modal>
  )
}